import Vue from 'vue';
import Component from 'vue-class-component';
import { modalHelper, DataItem } from '@/components/modal/modalHelper';
import { Async } from '@/utils/AsyncDecorators';
import { Watch } from 'vue-property-decorator';
import Form from "./form.vue";
import { areaSperimentaleStore } from '../store/areaSperimentale.store';
import { applyArrayChanges } from '@/utils/ApplyArrayChange';
import { versioneExSituStore } from '@/modules/VersioneExSitu/store/VersioneExSitu.store';
import { store } from '@/store';
import { layoutHelper } from '@/helpers/LayoutHelper';
import { localVersionHelper } from '@/helpers/LocalVersionHelper';
import Display from './display.vue';

Vue.component("area-sperimentale-item", () => !layoutHelper.isWeb ? import("./mobile/areaSperimentaleMobileItem.vue") : import("./web/areaSperimentaleWebItem.vue"));

@Component({})
export default class Index extends Vue {
  showSearchBar: boolean = false;

  @Async({ async get() { return (await areaSperimentaleStore.getters.getAll()).sort((a,b) => a.nome.localeCompare(b.nome)) }, default: [], lazy: true })
  aree: server.areaSperimentale[];
  
  @Async({ async get() { return await versioneExSituStore.getters.current() }, default: {}, lazy: false })
  currentVersion: server.VersioneExSitu;

  filter = {
    text: "",
  };

  selectedArea: server.areaSperimentale = null;

  applyFilter(items: server.areaSperimentale[]): server.areaSperimentale[] {
    return items.filter(i => ((i.nome || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0)
                          || ((i.provincia || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0)
                          || ((i.comune || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0)
                          || ((i.localita || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0)
    );
  };

  @Watch('filter.text') change(n, o) { this.showsize = 20; }
  showsize: number = 20;

  get areeOrdered(): server.areaSperimentale[] {
    return this.applyFilter(this.aree)
      // .sort((a, b) => b.dataRilievo.getTime() - a.dataRilievo.getTime())
      .slice(0, this.showsize);
  }

  async edit(item: server.areaSperimentale) {
    this.selectedArea = item;
    try {
      var result: DataItem<server.areaSperimentale>;
      if (localVersionHelper.get("ExSitu")) {
        result = await modalHelper.showModal<server.areaSperimentale>(Display, Object.assign({}, item));
      } else {
        result = await modalHelper.showModal<server.areaSperimentale>(Form, Object.assign({}, item));
      }
      applyArrayChanges([result], this.aree, (a, b) => a.id == b.id);
    } catch { }
    this.selectedArea = null;
  }

  async add() {
    try {
      let item: server.areaSperimentale = { versioneId: this.currentVersion.id, data: new Date(), datiCatastali:[], geoJSON:null } as server.areaSperimentale;
      let result = await modalHelper.showModal<server.areaSperimentale>(Form, Object.assign({}, item));
      applyArrayChanges([result], this.aree, (a, b) => a.id == b.id);
    } catch { }
  }

  async showChild(item: server.areaSperimentale) {
    modalHelper.closeModal();
    store.actions.ui.toggleDrawerMenu(false);
    store.actions.ui.toggleUserMenu(false);
    await store.actions.navigation.set_filter({area: "areaSperimentale", id: item.id} as server.navigation);
    this.$router.push({ name: "areeSpecieProvenienza" }).catch(err => { });
  }

  
  onShow(){
    return localVersionHelper.get("ExSitu") ? true : false
  }

}